import { useEffect } from "react";

export interface PageMeta {
  title: string;
  canonical: string;
  description?: string;
}

const SITE_NAME = "ChargeSuite";
const SITE_ORIGIN = "https://chargesuite.de";

export function usePageMeta({ title, canonical, description }: PageMeta): void {
  useEffect(() => {
    const fullTitle = title.includes(SITE_NAME)
      ? title
      : `${title} | ${SITE_NAME}`;
    document.title = fullTitle;

    const href = canonical.startsWith("http")
      ? canonical
      : `${SITE_ORIGIN}${canonical}`;
    let link = document.querySelector<HTMLLinkElement>('link[rel="canonical"]');
    if (!link) {
      link = document.createElement("link");
      link.rel = "canonical";
      document.head.appendChild(link);
    }
    link.href = href;

    if (description) {
      let meta = document.querySelector<HTMLMetaElement>(
        'meta[name="description"]',
      );
      if (!meta) {
        meta = document.createElement("meta");
        meta.name = "description";
        document.head.appendChild(meta);
      }
      meta.content = description;
    }
  }, [title, canonical, description]);
}
